import React from 'react';

import { DataGrid } from '@mui/x-data-grid';
import PropTypes from 'prop-types';

import { CustomPagination } from 'common/components';

const getRowStyles = (selectable) => {
    const styles = { '& .MuiDataGrid-cell:focus': { outline: 'none' } };
    if (selectable) styles['& .MuiDataGrid-row'] = { cursor: 'pointer' };
    return styles;
};

const Table = ({
    columns,
    isLoading,
    items,
    onPaginationModelChange,
    onRowClick,
    page,
    pageSize,
    paginationMode = 'client',
    rowCount,
    rowsPerPageOptions = [15, 25, 50, 75, 100],
    selectable = true,
    selectionModel,
}) => {
    const getRowHeight = () => 'auto';
    const initialState = {
        pagination: {
            paginationModel: { pageSize: rowsPerPageOptions[0] },
        },
    };
    const paginationModel = { page, pageSize };
    const slotProps = {
        pagination: {
            pageSizeOptions: rowsPerPageOptions,
        },
    };
    const slots = { pagination: CustomPagination };

    return (
        <DataGrid
            checkboxSelection={false}
            columns={columns || []}
            disableColumnMenu
            disableRowSelectionOnClick
            getRowHeight={getRowHeight}
            hideFooterSelectedRowCount
            initialState={initialState}
            loading={isLoading}
            onPaginationModelChange={onPaginationModelChange}
            onRowClick={onRowClick}
            pageSizeOptions={rowsPerPageOptions}
            pagination
            paginationMode={paginationMode}
            paginationModel={paginationModel}
            rowCount={rowCount}
            rowSelectionModel={selectionModel}
            rows={items || []}
            slotProps={slotProps}
            slots={slots}
            sx={getRowStyles(selectable)}
        />
    );
};

Table.propTypes = {
    columns: PropTypes.array,
    isLoading: PropTypes.bool,
    items: PropTypes.array,
    onPaginationModelChange: PropTypes.func,
    onRowClick: PropTypes.func,
    page: PropTypes.number,
    pageSize: PropTypes.number,
    paginationMode: PropTypes.string,
    rowCount: PropTypes.number,
    rowsPerPageOptions: PropTypes.array,
    selectable: PropTypes.bool,
    selectionModel: PropTypes.array,
};

export default Table;
